import { render } from "./Sport.vue?vue&type=template&id=4d311144"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"
script.render = render

export default script